import * as SalesStore from '../SalesStore';
import { Permission } from 'core/api';
import { Result } from 'core/infrastructure';
import { Preconditions } from 'core/infrastructure-next';
import { Command } from 'pos/common';

declare global {
	interface CommandType {
		completeMenu: () => Promise<Result>
	}
}

Command.register('completeMenu', Preconditions.ensure(Permission.Ticket_CompleteMenu), async (): Promise<Result> => {
	await SalesStore.completeMenu();
	return Result.ok();
});

